export const previewValues = {
  // Student
  student_mobile: "6375113875",
  student_registration_no: "SCAI01",
  student_name: "Abhishek Kumar",
  student_father_name: "SK",
  student_mother_name: "SK",
  student_father_occupation: "Business",
  student_email: "abhishekteam21@gmail.com",
  student_category: "OBC",
  student_aadhar: "123456789012",
  student_gender: "Male",
  student_dob: "15-Jan-2010",
  student_address: "Jaipur, Rajasthan, 302001",
  student_nic_id: "NIC12345",
  student_apaar_id: "APAAR12345",
  student_medium: "Hindi",
  student_admission_date: "01-Apr-2025",

  // Student otp
  student_otp: "123456",

  // Student Attendance
  student_attendance_status: "Present",
  student_attendance_status_hi: "उपस्थित",
  student_attendance_date: "05-Jun-2026",
  student_attendance_in_time: "09:00 AM",
  student_attendance_out_time: "04:00 PM",
  student_attendance_full:
    "Present | Date: 05-Jun-2026 Check In :09:00 AM - Check Out : 04:00 PM",

  // Student Enquiry
  student_enquiry_no: "ENQ001",
  student_enquiry_date: "05-Jun-2026",
  student_demo_days: "7",

  // Student Transaction
  student_transaction_status: "Success",
  student_transaction_date: "05-Jun-2026",
  student_transaction_amount: "5000",
  student_transaction_receipt_no: "RCPT001",
  student_transaction_method: "Online",
  student_transaction_module: "Tuition Fee",
  student_transaction_batch: "Batch A",
  student_due_amount: "2500",
  student_due_amount_session: "1000",

  // Test Details
  test_name: "Unit Test - 1",
  test_obtained_marks: 335,
  test_total_marks: 400,
  test_subject_wise_marks:
    "Math: 85/100 | Science: 78/100 | English: 90/100 | Hindi: 82/100",
  student_test_rank: 5,

  // Staff
  staff_mobile: "6375113875",
  staff_registration_no: "STF001",
  staff_name: "Abhishek Kumar",
  staff_father_name: "SK",
  staff_email: "abhishek@scai.in",
  staff_category: "Teaching",
  staff_aadhar: "987654321098",
  staff_gender: "Male",
  staff_dob: "01-Jan-1990",
  staff_address: "Jaipur, Rajasthan, 302001",
  staff_admission_date: "01-Apr-2024",

  // Staff Attendance
  staff_attendance_status: "Present",
  staff_attendance_date: "05-Jun-2026",
  staff_check_in_time: "08:45 AM",
  staff_check_out_time: "05:15 PM",
  staff_attendance_full:
    "Present | Date: 05-Jun-2026 Check In :09:00 AM - Check Out : 04:00 PM",

  // Holidays
  holiday_title: "Diwali Holiday",
  holiday_description: "Institute will remain closed on this day.",
  holiday_date: "20-Oct-2026",
  holiday_leave_type: "Full Day",

  // School
  school_name: "SCAI School",
  school_mobile: "6375113875",
  school_email: "info@scai.in",
  school_address: "Jaipur, Rajasthan, 302001",
};

export const messageSlugs = [
  "new_enquiry",
  "new_admission",
  "student_app_share",
  "student_fee_deposit",
  "student_absent",
  "student_present",
  "student_check_out",
  "student_long_absent",
  "student_low_attendance",
  "student_test_report",
  "student_password_reset_otp",
  "student_attendance_not_mark_alert_staff",
  "holiday_announcement",
  "staff_absent",
  "staff_check_in",
  "staff_check_out",
];
